export default class {
    constructor (UserSkillResource) {
        this.UserSkillResource = UserSkillResource;
    }

    countUsers (skillId) {
        if (!skillId) {
            return Promise.resolve(0);
        }
        return this.UserSkillResource.query({
            skillId,
            includeInactiveSkills: true,
            includeAnonymizedUsers: true
        }).$promise.then(result => {
            const items = result.items || result || [];
            return items.length;
        }).catch(() => 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/userSkill/index.js